import React from "react";
import { Switch, Route } from "react-router-dom";
import UnsubscribeView from "views/unsubscribe-views";
import Loading from "components/shared-components/Loading";
import { useThemeSwitcher } from "react-css-theme-switcher";

export const UnsubscribeLayout = () => {
  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  return (
    <div className="auth-container">
      <Switch>
        <Route path="" component={UnsubscribeView} />
      </Switch>
    </div>
  );
};

export default UnsubscribeLayout;
